module.exports = __webpack_public_path__ + "img/userLogo.648bddce.png";